import type {
  ActivityProductType,
  Coordinate,
  SearchTerm,
} from '@libs/trip-planner-interfaces';
import {
  IngredientType,
  AccommodationType,
} from '@libs/trip-planner-interfaces';

import type { ActivityIngredient } from './activityIngredient';
import { DestiationIngredient } from './destinationIngredient';

export interface OwnStayIngredientFilters {
  selectedActivityTypes: ActivityProductType[];
  activitiesFilterText: string;
}

export class OwnStayIngredient extends DestiationIngredient<IngredientType.OwnStay> {
  public static get defaultFilters(): OwnStayIngredientFilters {
    return {
      selectedActivityTypes: [],
      activitiesFilterText: '',
    };
  }

  public subIngredients: ActivityIngredient[] = [];

  public filters: OwnStayIngredientFilters = OwnStayIngredient.defaultFilters;

  public positionFromSearchText?: Coordinate;

  constructor(searchTerm: SearchTerm) {
    super(IngredientType.OwnStay, searchTerm);
  }

  public isIngredientCorrect(): boolean {
    return true;
  }

  public getSelectedActivityTypes(): ActivityProductType[] {
    let selectedActivityTypes = this.filters.selectedActivityTypes;

    if (selectedActivityTypes.length === 0) {
      selectedActivityTypes = [
        AccommodationType.Golf,
        AccommodationType.Ticket,
      ];
    }

    return selectedActivityTypes;
  }

  public resetAllFilters(): void {
    this.filters = OwnStayIngredient.defaultFilters;
  }
}
